import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppConfigService, WidgetService } from '@core/index';

@Component({
  selector: 'jb-callout-block-container',
  templateUrl: './callout-block-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalloutBlockContainerComponent {
  @Input() calloutBlock;
  hasImageHeightWidthAttr = false;
  enableLazyLoadImage: boolean;
  placeholderParams: string;

  constructor(
    private widgetService: WidgetService,
    private appConfig: AppConfigService,
  ) {
    this.hasImageHeightWidthAttr = this.appConfig.imageHeightWidthAttr;
    this.enableLazyLoadImage = this.appConfig.lazyLoadImages;
    this.placeholderParams = this.appConfig?.paths[0]?.placeholderImageParams;
  }

  onClick(event: Event, showChat): void {
    if (showChat === 'true') {
      event.preventDefault();
      this.widgetService.openASAPP();
    }
  }
}

export const calloutBlockContainerResolver = (registry, data) => {
  if (!!data.calloutBlock && !!data.calloutBlock.length) {
    data.calloutBlock.map(obj => {
      if (!obj.image || (!!obj.image && !obj.image[0].src)) {
        data.calloutBlock.map(block => {
          delete block.image;
        });
      }
      if (!obj.icon || (!!obj.icon && !obj.icon[0].src)) {
        data.calloutBlock.map(block => {
          delete block.icon;
        });
      }
      if (!obj.link || (!!obj.link && !obj.link[0].title)) {
        data.calloutBlock.map(block => {
          delete block.link;
        });
      }
    });
    return {
      calloutBlock: data.calloutBlock,
    };
  }
};
